// Loads third-party scripts (GA4 + tpembars ads) only after explicit consent.
// Idempotent: safe to call multiple times.
// gtag is already bootstrapped in index.html with send_page_view: false.

import { readConsent, onConsentChange } from "./consent";

const GA_ID = "G-13YPHRT2XL";
let gaLoaded = false;
let adsLoaded = false;

function gtag(...args: unknown[]) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const w = window as any;
  if (typeof w.gtag === "function") {
    w.gtag(...args);
  } else {
    w.dataLayer = w.dataLayer || [];
    w.dataLayer.push(args);
  }
}

function loadGA() {
  if (gaLoaded || typeof document === "undefined") return;
  gaLoaded = true;

  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  s.onload = () => {
    // The external script has loaded; emit the first page_view now that
    // analytics consent is granted.
    gtag("event", "page_view");
  };
  document.head.appendChild(s);
}

function loadAds() {
  if (adsLoaded || typeof document === "undefined") return;
  adsLoaded = true;
  const s = document.createElement("script");
  s.async = true;
  s.src = "https://tpembars.com/NTI1Njg3.js?t=525687";
  document.head.appendChild(s);
}

function apply() {
  const c = readConsent();
  if (!c) return;
  if (c.analytics) loadGA();
  if (c.ads) loadAds();
}

export function initConsentLoader() {
  // Defer to avoid blocking first paint.
  if (typeof window === "undefined") return;
  const run = () => {
    apply();
    onConsentChange(apply);
  };
  if (document.readyState === "complete") run();
  else window.addEventListener("load", run, { once: true });
}